import script from "./SailingTabView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SailingTabView.vue?vue&type=script&setup=true&lang=ts"

import "./SailingTabView.vue?vue&type=style&index=0&id=19e774fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e774fe"]])

export default __exports__